if (!customElements.get('bazaarvoice-inline-rating')) {
  class BazaarvoiceInlineRating extends HTMLElement {
    constructor() {
      super();
      this.debounceTimeout = null;
    }

    get reviewEl() {
      return this.querySelector('[data-bv-show="inline_rating"]');
    }

    get reviewLink() {
      if (this.reviewEl) return this.reviewEl.querySelector('a');
    }

    connectedCallback() {
      if (this.reviewEl) {
        let reviewObserver = new MutationObserver(() => this.debounce(this.displayReview.bind(this), 100));
        reviewObserver.observe(this.reviewEl, { childList: true });
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    debounce(func, delay) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(func, delay);
    }

    displayReview() {
      this.reviewEl.classList.add('hidden');
      const reviewCountContainer = this.reviewEl.querySelector('.bv_numReviews_component_container');
      if (reviewCountContainer) {
        const reviewCount = reviewCountContainer.querySelector('[itemprop="reviewCount"]');
        if (reviewCount) {
          const reviewCountValue = parseInt(reviewCount.getAttribute('content'), 0);
          if (reviewCountValue > 0) {
            if (this.reviewLink) {
              this.reviewLink.addEventListener('click', (event) => {
                event.preventDefault();
                document.querySelector('[id*="__bazaarvoice_"]').scrollIntoView({
                  behavior: 'smooth',
                });
              });
            }
            this.reviewEl.classList.remove('hidden');
          }
        }
      }
    }
  }

  customElements.define('bazaarvoice-inline-rating', BazaarvoiceInlineRating);
}
